/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailWithRelations } from './emailWithRelations';


/**
 * (tsType: EmailLogWithRelations, schemaOptions: { includeRelations: true })
 */
export interface EmailLogWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: number;
    emailId?: number;
    recipientEmail: string;
    status?: EmailLogWithRelations.StatusEnum;
    attempts?: number;
    personalVariables?: object;
    renderedSubject?: string;
    renderedHtml?: string;
    errorMessage?: string;
    sentAt?: string;
    lastAttemptAt?: string;
    email?: EmailWithRelations;
}
export namespace EmailLogWithRelations {
    export type StatusEnum = 'queued' | 'sending' | 'sent' | 'failed' | 'bounced';
    export const StatusEnum = {
        Queued: 'queued' as StatusEnum,
        Sending: 'sending' as StatusEnum,
        Sent: 'sent' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Bounced: 'bounced' as StatusEnum
    };
}


